var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar-wrapper",class:{
    'd-none': !_vm.isOpen,
    'd-block': _vm.isOpen
  },on:{"click":function($event){return _vm.toggleSidebar()}}},[_c('div',{staticClass:"sidebar bg-light border-right p-3",class:{
      'left-side': _vm.leftSide,
      'right-side': _vm.rightSide
    },on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"close",on:{"click":function($event){$event.stopPropagation();return _vm.toggleSidebar()}}},[_vm._v("Close X")]),_vm._t("sidebar-content",function(){return [_c('h5',[_vm._v("Sidebar")]),_vm._m(0)]}),_vm._t("main-content")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"list-unstyled"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Menu Item 1")])]),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Menu Item 2")])])])
}]

export { render, staticRenderFns }